import ApiService from './ApiService'

export async function apiGetNotificationCount() {
    return ApiService.fetchData({
        url: '/notification/count',
        method: 'get',
    })
}

export async function apiGetNotificationList() {
    return ApiService.fetchData({
        url: '/notification/list',
        method: 'get',
    })
}

export async function apiGetSearchResult(data) {
    return ApiService.fetchData({
        url: '/search/query',
        method: 'post',
        data,
    })
}
export async function apiSaveSubscriptionChanges(data) {
    return ApiService.fetchData({
        url: '/billing/save-subscription-changes',
        method: 'post',
        data,
    })
}
export async function apiUnsubscribeTitles(data) {
    return ApiService.fetchData({
        url: '/billing/unsubscribe-titles',
        method: 'post',
        data,
    })
}
export async function apiGetApiKey() {
    return ApiService.fetchData({
        url: '/billing/get-user-api-key',
        method: 'get',
    })
}
export async function apiGetInvoicePdf(data) {
    return ApiService.fetchData({
        url: '/billing/get-invoice-pdf',
        method: 'post',
        data,
        headers: { Accept: 'application/pdf' },
    })
}
export async function apiGetTermsOfUse() {
    return ApiService.fetchData({
        url: '/get-terms-of-use',
        method: 'get',
    })
}
